import { useContext } from "react";
import { BreadcrumbContext } from "../context/BreadcrumbContext";

const useBreadcrumb = () => {
  const { breadcrumbData, setBreadcrumbData } = useContext(BreadcrumbContext);
  return [breadcrumbData, setBreadcrumbData];
};

export default useBreadcrumb;
